module.exports = __webpack_public_path__ + "img/weixin_nan.6cee305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weixin_nan.png
// module id = r0G2
// module chunks = 1